// "@email.com", "email.com"
export const EMAIL_DOMAIN_REGEX = /^@?((([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Source: https://emailregex.com/
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
